const MISSED_ORIGINS = new Set(['prior']);

export const isMissedFinding = (finding) => MISSED_ORIGINS.has(finding?.detection_origin);

export const getOriginLabelKeys = (origin) => {
  if (origin === 'second_capture') {
    return {
      long: 'diagnose.second_capture_finding',
      short: 'diagnose.second_capture_finding',
      explanation: 'diagnose.second_capture_finding_explanation',
    };
  }
  if (origin === 'prior') {
    return {
      long: 'diagnose.prior_finding',
      short: 'diagnose.prior_finding_short',
      explanation: 'diagnose.prior_finding_explanation',
    };
  }
  return {
    long: 'diagnose.prior_finding',
    short: 'diagnose.prior_finding_short',
    explanation: 'diagnose.prior_finding_explanation',
  };
};

const bucketVisible = (findings, showMissedFindings) => {
  if (!findings.length) return false;
  if (findings.some((f) => !isMissedFinding(f))) return true;
  return showMissedFindings && findings.some(isMissedFinding);
};

export const overlayZoomExist = (type, projectionData, showMissedFindings = false) => {
  const findings = projectionData?.[type];
  if (!Array.isArray(findings)) return false;
  return bucketVisible(findings, showMissedFindings);
};

export const overlaysExist = (type, data, showMissedFindings = false) => {
  if (!data) return false;
  return Object.values(data).some(
    (projectionData) => projectionData && overlayZoomExist(type, projectionData, showMissedFindings),
  );
};

export const overlayExists = (type, result, zoomedProjection, showMissedFindings = false) => {
  if (zoomedProjection) {
    return overlayZoomExist(type, result?.[zoomedProjection.toLowerCase()], showMissedFindings);
  }
  return overlaysExist(type, result, showMissedFindings);
};

export const shouldShowFinding = (finding, showMissedFindings) =>
  !isMissedFinding(finding) || showMissedFindings;

export const getMissedChip = (opacitiesResult) => {
  const origins = new Set();
  if (opacitiesResult) {
    Object.values(opacitiesResult).forEach((projectionData) => {
      if (!projectionData) return;
      Object.values(projectionData).forEach((findings) => {
        if (!Array.isArray(findings)) return;
        findings.forEach((finding) => {
          if (isMissedFinding(finding)) origins.add(finding.detection_origin);
        });
      });
    });
  }

  return {
    missedExist: origins.size > 0,
    missedChipLabelKeys: getOriginLabelKeys([...origins][0]),
  };
};
